import Navbar from "./Navbar";
import CourseCatalog from "./Courses/All_Courses";
import CourseReviews from "./Courses/Course_Review";
import Footer from "./Footer";
import './Css/Courses.css';
import StaticData from "./Courses/Static_Data";

function Courses() {
  return (
    <div>
      <Navbar />
      <CourseCatalog />
      <StaticData />
      <CourseReviews />
      <Footer />
    </div>
  );
}

export default Courses;